if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
        this.buyNow = this.querySelector('.shopify-payment-button__button');
        if (this.buyNow) {
          this.buyNow.addEventListener('click', this.handleBuyNowClick.bind(this));
        }
        this.variantDropdown = this.querySelector('.product-form__variants');
        this.selectedVariantID = this.querySelector('.product-variant-id').value;
      }
      returnCurrentVariant(){
        const SelectedOption = Array.from(this.variantDropdown.options)
        .filter(option => option.value === this.selectedVariantID).map(option => option)[0];
        console.log(SelectedOption,this.querySelector('.product-form__variants'));
        const variantQty = SelectedOption.dataset.variantQty;
        const variantPolicy = SelectedOption.dataset.inventory_policy;
        const variantSKU = SelectedOption.dataset.sku
        let variantRingSize;
        if(theme.productTags.includes('galaxy-star')){
          variantRingSize = document.querySelector("#custom_ringSize") && document.querySelector("#custom_ringSize").value;
        }
        if(theme.productTags.includes('infinity-star')){
          console.log(document.querySelector("#custom_ringSize input:checked"));
          variantRingSize = document.querySelector("#custom_ringSize input:checked").value;
        }
        return [variantQty,variantPolicy,variantSKU,variantRingSize];
      }
      addToCartData() {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const timestamp = new Date().getTime();
        const originalFormData = new FormData(this.form);
        const mainVariantId = originalFormData.get("id");
        const mainQuantity = originalFormData.get("quantity") || 1;
        const mainProperties = {};
        for (const [key, value] of originalFormData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) {
            mainProperties[match[1]] = value;
          }
        }
        const [variantQty, variantPolicy, variantSKU, variantRingSize] = this.returnCurrentVariant();
        const productVendor = theme.productTags.includes('starwars-fine-jewelry') ? 'Star Wars' : theme.productTags.includes('disney-fine-jewelry') ? 'Disney' : "Marvel";
        if (theme.productTags.includes('galaxy-star') || theme.productTags.includes('infinity-star')) {
          mainProperties["Size"] = variantRingSize;
          mainProperties["_SKU with size"] = `${variantSKU}${variantRingSize}`;
        }
        if (theme.productTags.includes('personalized-collection')) {
          const engravingText = document.querySelector('#embros_txt')?.value;
          const engravingFont = document.querySelector('.font-familt-grid input:checked')?.value;
          if (engravingText?.length) {
            mainProperties["_Personalized"] = "Order";
            mainProperties["Engraved Text"] = engravingText;
            mainProperties["Font"] = engravingFont;
          }
        }
        if (theme.productTags.includes('disney-personalized')) {
          const engravingText1 = document.querySelector('#engrav-input-1');
          const engravingText2 = document.querySelector('#engrav-input-2');
          const engravingFont = document.querySelector('.font-buttons .font-btn.active')?.innerText;
          const engravingText1Available = engravingText1 && engravingText1.value.length;
          const engravingText2Available = engravingText2 && engravingText2.value.length;
          if (engravingText1Available || engravingText2Available) {
            mainProperties["_Personalized"] = "Order";
            mainProperties["Font"] = engravingFont;
          }
          if (engravingText1Available) {
            mainProperties["Engraved Text 1"] = engravingText1.value;
          }
          if (engravingText2Available) {
            mainProperties["Engraved Text 2"] = engravingText2.value;
          }
        }
        if (variantPolicy == "continue" && variantQty < 1) {
          mainProperties["Shipping Time"] = "2 weeks";
        }
        mainProperties["_Product Vendor"] = productVendor;
        mainProperties["_timestamp"] = timestamp;

        let protectionVariantId = null;
        const protectionProperties = {};
        const checkedProtectionInput = document.querySelector('.product-clarity-commitment .protection-plan-wrapper input[name="protection_plan"]:checked');
        if (checkedProtectionInput) {
          const protectionGridItem = checkedProtectionInput.closest(".grid__item");
          const productInfoParent = document.querySelector('.product__info-container');
          if (protectionGridItem?.dataset.protectionId && productInfoParent) {
            protectionVariantId = protectionGridItem.dataset.protectionId;
            protectionProperties["_product name"] = productInfoParent.querySelector('h1')?.textContent?.trim();
            const priceEl = productInfoParent.querySelector('.price-item--regular') || productInfoParent.querySelector('.price-item--sale');
            protectionProperties["_product price"] = priceEl?.textContent?.trim();
            protectionProperties["_product SKU"] = productInfoParent.querySelector('.product-sku-copy')?.textContent?.trim();
            protectionProperties["_timestamp"] = timestamp;
          }
        }

        const multiFormData = new FormData();
        multiFormData.append("items[0][id]", mainVariantId);
        multiFormData.append("items[0][quantity]", mainQuantity);
        Object.entries(mainProperties).forEach(([propName, propValue]) => {
          multiFormData.append(`items[0][properties][${propName}]`, propValue);
        });

        if (protectionVariantId) {
          multiFormData.append("items[1][id]", protectionVariantId);
          multiFormData.append("items[1][quantity]", 1);
          Object.entries(protectionProperties).forEach(([propName, propValue]) => {
            multiFormData.append(`items[1][properties][${propName}]`, propValue);
          });
        }

        if (this.cart) {
          multiFormData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          multiFormData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = multiFormData;
        return [config, multiFormData];
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.submitButton.querySelector(".loading__spinner").classList.remove("hidden");
        // return false;

        const [config,formData] =  this.addToCartData();

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("items[0][id]"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("items[0][id]"),
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.querySelector(".loading__spinner").classList.add("hidden");
          });
      }
      handleBuyNowClick() {
        const [variantQty,variantPolicy,variantSKU,variantRingSize] = this.returnCurrentVariant();
        if (!this.buyNow) return;
        console.log(variantQty,variantPolicy,variantSKU,variantRingSize,routes.cart_clear_url);
        
        this.buyNow.setAttribute("aria-disabled", true);
        this.buyNow.classList.add("loading");
        this.buyNow.querySelector(".loading__spinner").classList.remove("hidden");

        fetch(`${routes.cart_clear_url}`,{
          method: 'POST',
          headers: {
            "Content-Type": "application/json", // Set the content type
          },
        })
          .then((response) => response)
          .then((response) => {
            const [config,formData] =  this.addToCartData();
            fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              console.log(response);
              window.location.href = '/checkout'
            })
          })
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.buyNow.style.display = 'none';
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.buyNow.style.display = 'block';
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
